import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { UserStore } from 'src/Stores/User/UserStore';


interface IUserPreferencesProps {
    preferences: object;
    handlePreferenceChange: (preference: string, value: string) => void;
}

interface IAllOptions {
    name: string;
    permission: string;
}

@inject('stores')
@observer
export class UserPreferences extends React.Component {
    public props: IUserPreferencesProps;

    private UserStore: UserStore;
    constructor(props: any) {
        super(props);
        this.UserStore = props.stores.UserStore;
    }

    public handleCheckBox = (falseVal?: string, noPrefChecked?: boolean) => (event: any) => {
        const preferences = this.props.preferences;
        const currPref = preferences[event.target.name];
        if (currPref === 'true' || (currPref === undefined && noPrefChecked)) {
            this.props.handlePreferenceChange(event.target.name, falseVal ? falseVal : '');
        } else {
            this.props.handlePreferenceChange(event.target.name, 'true');
        }
    }

    public handleRadio = (opt: string) => (event: any) => {
        this.props.handlePreferenceChange(event.target.name, opt);
    }

    public handleAllCheckBox = (root: string, items: Array<string | IAllOptions>, falseVal?: string, noPrefChecked?: boolean) => () => {
        const preferences = this.props.preferences;
        const list = this.mapList(root, items);
        const checked = list.every(i => preferences[i] === 'true' || (noPrefChecked ? preferences[i] === undefined : false));
        list.forEach(li => this.props.handlePreferenceChange(li, checked ? (falseVal ? falseVal : '') : 'true'));
    }

    private mapList = (root: string, items: Array<string | IAllOptions>) => {
        return items.map(i => {
            if (typeof i === 'object')
            {
                if (this.UserStore.hasPermission(i.permission)) {
                    return root + "." + i.name;
                } else {
                    return root;
                }
            }
            return root + "." + i;
        }).filter(i => i !== root);
    }
    public renderAllCheckBox = (root: string, items: Array<string | IAllOptions>, noPrefChecked?: boolean) => {
        const preferences = this.props.preferences;
        const list = this.mapList(root, items);
        const checked = list.every(i => preferences[i] === 'true' || (noPrefChecked ? preferences[i] === undefined : false));

        return <FormGroup style={{marginLeft: '1.5rem'}} check={true}>
            <Label check={true}>
                <Input
                    key={root + '.All'}
                    type="checkbox"
                    name={root + '.All'}
                    checked={checked}
                    onChange={this.handleAllCheckBox(root, items, noPrefChecked ? 'false' : '', noPrefChecked)}
                />
                All
            </Label>
        </FormGroup>;
    }
    public renderPreferenceCheckBox = (name: string, display: string, noPrefChecked?: boolean) => {
        const preferences = this.props.preferences;
        return <FormGroup style={{marginLeft: '1.5rem'}} check={true}>
            <Label check={true}>
                <Input
                    key={name}
                    type="checkbox"
                    name={name}
                    checked={preferences[name] ? preferences[name] === 'true' : noPrefChecked ? true : false}
                    onChange={this.handleCheckBox(noPrefChecked ? 'false' : '', noPrefChecked)}
                />
                {display}
            </Label>
        </FormGroup>;
    }

    public renderPreferenceRadio = (name: string, displayOpt: string[], options: string[]) => {
        if (displayOpt.length !== options.length) {
            throw new Error("Must have same number of display options as options");
        }
        const preferences = this.props.preferences;
        return <React.Fragment>
        {
            options.map((opt, index) => 
                <FormGroup style={{marginLeft: '1.5rem'}} check={true} key={opt}>
                    <Label check={true}>
                        <Input
                            key={name + "." +opt}
                            type="radio"
                            name={name}
                            checked={preferences[name] ? preferences[name] === opt : false}
                            onChange={this.handleRadio(opt)}
                        />
                        {displayOpt[index]}
                    </Label>
                </FormGroup>
            )
        }
        </React.Fragment>;
    }

    public render() {
        return <Row>
            <Col>
                <h4>
                    User Preferences
                </h4>
                {
                    (this.UserStore.hasPermission("Permissions.Wells.Read.All")
                    || this.UserStore.hasPermission("Permissions.Wells.Read.Seperate"))
                    &&
                    <div style={{marginBottom: '1rem'}}>
                        <h5>Well List View Assignment</h5>
                        {
                            this.renderPreferenceRadio("Preferences.Wells.Assignment", ['All', 'Assigned'], ['All', 'Assigned'])
                        }
                    </div>
                }
                {
                    this.UserStore.hasGenericPermission("Permissions.Wells.ReadClosed") &&
                    <div style={{marginBottom: '1rem'}}>
                        <h5>Well List View Status</h5>
                        {
                            this.renderAllCheckBox("Preferences.Wells.List", 
                            [
                                "Active",
                                "Finishing",
                                "Closed",
                                {
                                    name: 'Archived',
                                    permission: 'Permissions.Wells.ViewArchive'
                                }
                            ])
                        }
                        {this.renderPreferenceCheckBox("Preferences.Wells.List.Active", "Active")}
                        {this.renderPreferenceCheckBox("Preferences.Wells.List.Finishing", "Finishing")}
                        {this.renderPreferenceCheckBox("Preferences.Wells.List.Closed", "Closed")}
                        {   this.UserStore.hasPermission("Permissions.Wells.ViewArchive") &&
                            this.renderPreferenceCheckBox("Preferences.Wells.List.Archived", "Archived")
                        }
                        {
                            this.UserStore.hasPermission("Permissions.Wells.NotifyNew") &&
                            this.renderPreferenceCheckBox("Preferences.Wells.NotifyNew", "Notify on New Well")
                        }
                        {
                            this.UserStore.hasPermission("Permissions.Wells.NotifyFinish") &&
                            this.renderPreferenceCheckBox("Preferences.Wells.NotifyFinish", "Notify when Well goes from Active to Finish")
                        }
                    </div>
                }
                {
                    this.UserStore.hasGenericPermission("Permissions.Dispatch.Read") &&
                <React.Fragment>
                    <div style={{marginBottom: '1rem'}}>
                        <h5>Dispatch List View Type</h5>
                        {
                            this.renderAllCheckBox("Preferences.Dispatch.List.Type", [
                                "Delivery",
                                "Pickup",
                                "Transfer",
                            ])
                        }
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Type.Delivery", "Delivery")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Type.Pickup", "Pickup")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Type.Transfer", "Transfer")}
                    </div>
                    <div style={{marginBottom: '1rem'}}>
                        <h5>Dispatch List View Status</h5>
                        {
                            this.renderAllCheckBox("Preferences.Dispatch.List.Status", [
                                "Submitted",
                                "Rejected",
                                "Approved",
                                "Confirmed",
                                "Denied",
                                "Completed",
                                "Cancelled",
                            ])
                        }
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Status.Submitted", "Submitted")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Status.Rejected", "Rejected")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Status.Approved", "Approved")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Status.Confirmed", "Confirmed")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Status.Denied", "Denied")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Status.Completed", "Completed")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.List.Status.Cancelled", "Cancelled")}
                    </div>
                    <div style={{marginBottom: '1rem'}}>
                        <h5>Dispatch Notifications</h5>
                        {
                            this.renderAllCheckBox("Preferences.Dispatch.Notifications", [
                                "Submitted",
                                "Rejected",
                                "Approved",
                                "Confirmed",
                                "Denied",
                                "Comment",
                            ])
                        }
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.Notifications.Submitted", "Submitted")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.Notifications.Rejected", "Rejected")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.Notifications.Approved", "Approved")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.Notifications.Confirmed", "Confirmed")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.Notifications.Denied", "Denied")}
                        {this.renderPreferenceCheckBox("Preferences.Dispatch.Notifications.Comment", "Comments")}
                    </div>
                </React.Fragment>
                }
            </Col>
        </Row>;
    }

}


// WEBPACK FOOTER //
// ./src/Components/Main/Profile/UserPreferences.tsx